import { configureStore } from '@reduxjs/toolkit';

import userReducer from './userData/userDataSlice';

const store = configureStore({
  reducer: {
    userdata: userReducer,
  },
});

export default store;
